import React, { useEffect } from "react";
import CloseIcon from "@mui/icons-material/Close";
import "./MenuShelf.css";

// Phones: categories, settings and About in a shelf that slides in from the
// right, so the globe gets the whole screen. `children` are the category and
// settings buttons (the desktop category picker's).
export default function MenuShelf({ open, onClose, children }) {
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => { if (e.key === "Escape") onClose(); };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  return (
    <div className={`menu-shelf${open ? " is-open" : ""}`} aria-hidden={!open}>
      <div className="menu-shelf__backdrop" onClick={onClose} />
      <nav className="menu-shelf__panel ui-panel" aria-label="Menu">
        <div className="menu-shelf__header">
          <span>Menu</span>
          <button type="button" className="menu-shelf__close" onClick={onClose} aria-label="Close menu">
            <CloseIcon />
          </button>
        </div>
        <div className="menu-shelf__body">
          {children}
          <section className="menu-shelf__about" aria-label="About">
            <h2>Welcome to paleblue.news</h2>
            <p>World news from a global perspective.</p>
            <p>Turn the globe and pick a place to read its stories. Use the timeline to travel back through the news.</p>
            <p>We believe that this view provides important global context that is lost when browsing traditional news websites.</p>
            <p>
              This concept is inspired by the <a href="https://en.wikipedia.org/wiki/Overview_effect">overview effect</a>.
              The name is a reference to <a href="https://en.wikipedia.org/wiki/Pale_Blue_Dot">Pale Blue Dot</a>.
            </p>
            <p>
              <a href="mailto:contact@paleblue.news">Email us</a>
              {" · "}
              <a href="https://twitter.com/palebluenews">Follow on X</a>
            </p>
          </section>
        </div>
      </nav>
    </div>
  );
}
